import api from "./api";

const buildDateParams = (params = {}) => {
  const q = { ...(params || {}) };
  if (q.year != null && q.year !== "" && !q.from && !q.to) {
    const y = parseInt(String(q.year), 10);
    if (Number.isFinite(y)) {
      q.from = `${y}-01-01`;
      q.to = `${y}-12-31`;
    }
  }
  return q;
};

const dashboardService = {
  getAdminStats: (params) =>
    api.get("/dashboard/admin-dashboard-stats", { params: buildDateParams(params) }),
  getInstituteStats: (params) =>
    api.get("/dashboard/institute-dashboard-stats", { params: buildDateParams(params) }),
  getHodStats: (params) =>
    api.get("/dashboard/hod-dashboard-stats", { params: buildDateParams(params) }),
  // Add cache-buster to avoid 304/stale dashboard stats
  getTeacherStats: (params) =>
    api.get("/dashboard/teacher-dashboard-stats", { params: { ...(params || {}), t: Date.now() } }),

  // Enhanced HOD Dashboard
  getHodClassWiseStudents: () => api.get("/dashboard/hod-classwise-students"),
  // Enhanced Teacher Dashboard
  getTeacherClassWiseStudents: () => api.get("/dashboard/teacher-classwise-students", { params: { t: Date.now() } }),
  exportHodClassRoster: (params) => api.get("/dashboard/hod-class-roster-export", { params }),

  // Enhanced Admin Dashboard (pass instituteId for super admin without JWT institute)
  getDashboardInstitutesForFilter: () => api.get("/dashboard/institutes-for-filter"),
  getAdminDepartmentDistribution: (params = {}) => api.get("/dashboard/admin-department-distribution", { params }),
  getAdminDepartmentClasses: (departmentId, params = {}) =>
    api.get("/dashboard/admin-department-classes", { params: { departmentId, ...params } }),
  getAdminAttendanceHeatmap: (params = {}) => api.get("/dashboard/admin-attendance-heatmap", { params }),
  exportAdminDepartmentDrilldown: (params = {}) => api.get("/dashboard/admin-department-drilldown-export", { params }),
  exportAdminClassesSpecial: (params = {}) => api.get("/dashboard/admin-classes-special-export", { params }),
  exportAdminDepartmentsType: (params = {}) => api.get("/dashboard/admin-departments-type-export", { params }),
};

export default dashboardService;